import { gql } from '@apollo/client';

export const ADD_UPDATE_CHECKLIST = gql`
  mutation addOrUpdateChecklist($input: ChecklistItemInput) {
    addOrUpdateChecklist(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_CHECKLIST_TYPE_PROPERTIES = gql`
  mutation addOrUpdateChecklistTypeProperties($input: ChecklistTypePropertyInput) {
    addOrUpdateChecklistTypeProperties(input: $input) {
      commandId
    }
  }
`;

export const SAVE_FILTERS_CHECKLIST = gql`
  mutation saveChecklistFilters($input: ChecklistTypeFiltersInput) {
    saveChecklistFilters(input: $input) {
      commandId
    }
  }
`;

export const SAVE_CHECKLIST_USER_GROUPS = gql`
  mutation saveChecklistXUserGroups($input: ChecklistXUserGroupsInput) {
    saveChecklistXUserGroups(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const VERIFY_CHECKLIST = gql`
  mutation verifyChecklist($input: VerifyChecklistItemInput) {
    verifyChecklist(input: $input) {
      commandId
    }
  }
`;
